import { ViewModelBase } from "@shoothill/core";
import { makeObservable } from "mobx";

import { MentorAbsenceModelModelValidator, MentorAbsenceModel } from "./MentorAbsenceModel";
import { ManagersModule } from "./Managers";

export class MentorAbsenceViewModel extends ViewModelBase<MentorAbsenceModel> {
    public managers!: ManagersModule;

    constructor() {
        super(new MentorAbsenceModel());
        this.setValidator(new MentorAbsenceModelModelValidator());
        this.managers = new ManagersModule(this);
        makeObservable(this, {});
    }

    /** Loads mentors. Call from the consuming view's useEffect, not from constructor. */
    public async initialize(): Promise<void> {
        await this.managers.api.loadMentors();
    }

    // ─── Domain data — delegated ──────────────────────────────────────────────

    public get mentorOptions() {
        return this.managers.domain.mentorOptions;
    }
    public get getAbsenceShift() {
        return this.managers.domain.absenceShiftOptions;
    }
    public get getAbsenceTime() {
        return this.managers.domain.absenceTimeOptions;
    }
    public get filteredMentorAbsenceTime() {
        return this.managers.domain.filteredAbsenceTimeOptions;
    }

    public get canSubmitForm(): boolean {
        return this.isModelValid();
    }

    // ─── MobX state — delegated ───────────────────────────────────────────────

    public get submittedSuccessfully(): boolean {
        return this.managers.mobx.submittedSuccessfully;
    }

    // ─── Commands — delegated ─────────────────────────────────────────────────

    public get updateMentorAbsenceStartDateCommand() {
        return this.managers.commands.updateMentorStartDateCommand;
    }
    public get updateMentorAbsenceEndDateCommand() {
        return this.managers.commands.updateMentorEndDateCommand;
    }
    public get updateMentorAbsenceShiftCommand() {
        return this.managers.commands.updateMentorShiftCommand;
    }
    public get updateMentorAbsenceTimeCommand() {
        return this.managers.commands.updateMentorTimeCommand;
    }
    public get updateMentorSelectTimeCommand() {
        return this.managers.commands.updateMentorSelectCommand;
    }

    /** Returns a save command bound to the given parent ViewModel. */
    public addMentorAbsenceCommand(parentViewModel: any) {
        return this.managers.commands.addMentorAbsenceCommand(parentViewModel);
    }
}
